/**
 * Block B.9: экран «бот недоступен» — показывается при 401/403 от API.
 *
 * Возможные причины:
 * - Партнёр поставил бота на паузу или удалил.
 * - Аккаунт клиента заблокирован системой.
 * - JWT истёк и WebApp нужно перезайти.
 *
 * UX: явная карточка с emoji + объяснением + CTA «Связаться с поддержкой» (если
 * support_url задан в branding партнёра — но мы не знаем какой, так что fallback
 * на @support).
 */

import { useTranslation } from 'react-i18next';
import { Bot, AlertTriangle } from 'lucide-react';
import { getWebApp } from '@/lib/telegram';

export function BotDisabledScreen() {
  const { t } = useTranslation();

  const handleClose = () => {
    const tg = getWebApp();
    tg?.close();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 space-y-6">
      <div className="relative">
        <div className="w-24 h-24 rounded-3xl bg-red-500/15 border border-red-500/30 flex items-center justify-center">
          <Bot className="w-12 h-12 text-red-500" />
        </div>
        <div className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-red-500 flex items-center justify-center border-2 border-background">
          <AlertTriangle className="w-4 h-4 text-white" />
        </div>
      </div>
      <div className="text-center space-y-2 max-w-sm">
        <h2 className="text-xl font-bold">{t('Disabled title')}</h2>
        <p className="text-sm text-muted-foreground">{t('Disabled description')}</p>
      </div>
      <button
        type="button"
        onClick={handleClose}
        className="px-6 py-3 bg-primary text-primary-foreground rounded-xl text-sm font-bold"
      >
        {t('Disabled close')}
      </button>
    </div>
  );
}
